import { FC, InputHTMLAttributes } from 'react';

import classes from './style.module.css';

interface SubmitInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}
export const SubmitInput: FC<SubmitInputProps> = ({
  className, ...rest
}) => (
  <input
    type="submit"
    className={className || classes.submit}
    {...rest}
  />
);
